import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import BlockForm from '../../components/admin/BlockForm';
import blocksApi from "../../components/admin/blocksApi";
import toast from "react-hot-toast";

import '../../components/admin/AdminForms.css';

const AdminEditBlock = () => {
  const { id } = useParams();
  const [block, setBlock] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const loadBlock = async () => {
      try {
        setLoading(true);
        const response = await blocksApi.getBlocks({
          id: id
        });

        if (response.blocks && response.blocks.length > 0) {
          setBlock(response.blocks[0]);
        } else {
          toast.error('Block not found');
        }
      } catch (error) {
        console.error('Error loading block:', error);
        toast.error('Failed to load block');
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      loadBlock();
    }
  }, [id]);

  // ✅ Handle form submission
  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      console.log('Form data:', data);

      const payload = {
        title: data.title,
        identifier: data.identifier,
        content: data.content,
        isActive: data.isActive,
      };

      console.log('Updating block with payload:', payload);
      
      const response = await blocksApi.updateBlock(id, payload);
      
      console.log('Update response:', response);
      toast.success("Block updated successfully!");
      
      // Optionally navigate back to blocks list
      // navigate("/admin/blocks");
    } catch (error) {
      console.error("Error updating block:", error);
      
      // Handle specific error messages
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to update block");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-block">
          <div className="admin-card">
            <div className="admin-card-header">
              <h2 className="admin-card-title">Loading...</h2>
            </div>
          </div>
        </div>
      </AdminLayout>
    );
  }

  if (!block) {
    return (
      <AdminLayout>
        <div className="admin-block">
          <div className="admin-card">
            <div className="admin-card-header">
              <h2 className="admin-card-title">Block not found</h2>
            </div>
          </div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <BlockForm
        block={block}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        title="Edit Block"
        submitButtonText="Save Changes"
      />
    </AdminLayout>
  );
};

export default AdminEditBlock;